import { DocumentNode, useMutation } from "@apollo/client";

export default function useOrderMutations<T,U>(documentNode: DocumentNode) {

    return useMutation<T,U>(documentNode);

}